.container {
    display: grid;
    grid-template-columns: auto 1fr;
}

.grouping-line-container {
    grid-column: 1;
    grid-row: 2;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding-left: 28px;
}

.left-grouping-line {
    width: 1px;
    background-color: var(--grey-xlt);
    margin-top: 4px;
    position: relative;
    height: calc(100% - 12px);
}

.content {
    grid-column: 2 / 4;
    grid-row: 2;
    gap: 8px;
    display: flex;
    flex-direction: column;
    width: 100%;
}
